<template>
	<div class="resource-planning-icon">
		<a
			v-if="isLink"
			v-tooltip="text"
			class="resource-planning-icon__text resource-planning__project-link"
		>
			{{ text }}
		</a>
		<template v-else>
			{{ text }}
		</template>
		<SuiIcon
			v-tooltip="tooltip"
			class="resource-planning-icon__icon"
			:name="name"
			:fill="fill"
		/>
	</div>
</template>
<script setup lang="ts">
import { SuiIcon } from '@developers/scoro-ui';
import { type Project } from '@/generated/graphql';

defineProps<{
	name: string;
	text?: string;
	tooltip?: string;
	fill?: NonNullable<Project['color']>;
	isLink?: boolean;
}>();
</script>

<style lang="scss">
.resource-planning-icon {
	display: contents;
	align-items: center;
	gap: 1rem;

	&__text {
		display: inline-block;
		max-width: 22rem;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
}
</style>
